module.exports = JSON.parse('{"languageSwitcher":{"label":"Тил"},"close":"Жабуу","pageTitle":"Жаңы жыл 2027 — Ашыкча эч нерсе жок! | NL International"}')